import { tableIds } from '../../../components/display/tables/types';
import { LOADING_DATA } from '../../actions/ui/loadingData';

export const initialLoadingDataState = {
  [tableIds.DUPLICATE_COMMUNICATION]: {
    id: tableIds.DUPLICATE_COMMUNICATION,
    isLoadingData: false,
  },
  [tableIds.WORKORDER_COMMUNICATIONS]: {
    id: tableIds.WORKORDER_COMMUNICATIONS,
    isLoadingData: false,
  },
  [tableIds.SEARCH_AND_CREATE_HISTORICAL_COMMUNICATIONS]: {
    id: tableIds.SEARCH_AND_CREATE_HISTORICAL_COMMUNICATIONS,
    isLoadingData: false,
  },
  [tableIds.WORKORDER_GENERAL_VIEW]: {
    id: tableIds.WORKORDER_GENERAL_VIEW,
    isLoadingData: false,
  },
  [tableIds.DUPLICATE_GENERIC_ORDER]: {
    id: tableIds.DUPLICATE_GENERIC_ORDER,
    isLoadingData: false,
  },
  [tableIds.SEARCH_AND_CREATE_HISTORICAL_WORKORDERS]: {
    id: tableIds.SEARCH_AND_CREATE_HISTORICAL_WORKORDERS,
    isLoadingData: false,
  },
  [tableIds.ACCIDENTS]: {
    id: tableIds.ACCIDENTS,
    isLoadingData: false,
  },
  [tableIds.CAMPAIGNS]: {
    id: tableIds.CAMPAIGNS,
    isLoadingData: false,
  },
  [tableIds.MULTIMEDIA]: {
    id: tableIds.MULTIMEDIA,
    isLoadingData: false,
  },
  [tableIds.GENERIC_ORDER_MODAL]: {
    id: tableIds.GENERIC_ORDER_MODAL,
    isLoadingData: false,
  },
  [tableIds.CAMPAIGN_MODAL]: {
    id: tableIds.CAMPAIGN_MODAL,
    isLoadingData: false,
  },

  [tableIds.VALIDATION_ACTIONS]: {
    id: tableIds.VALIDATION_ACTIONS,
    isLoadingData: false,
  },
  [tableIds.SURVEILLANCE_ROUTES]: {
    id: tableIds.SURVEILLANCE_ROUTES,
    isLoadingData: false,
  },
  [tableIds.SEARCH_AND_CREATE_HISTORICAL_SURVEILLANCE_ROUTES]: {
    id: tableIds.SEARCH_AND_CREATE_HISTORICAL_SURVEILLANCE_ROUTES,
    isLoadingData: false,
  },

  // FIX (loader-loading-flag-leak audit): añadir keys que faltaban del initial
  // state. Antes del fix funcionaban "por accidente" (selector retornaba
  // undefined → tratado como false), pero romper esa asunción podría
  // introducir bugs sutiles. Mejor explícito.
  [tableIds.GENERAL_ACTIONS]: {
    id: tableIds.GENERAL_ACTIONS,
    isLoadingData: false,
  },
  [tableIds.SEARCH_AND_CREATE_HISTORICAL_ACTIONS]: {
    id: tableIds.SEARCH_AND_CREATE_HISTORICAL_ACTIONS,
    isLoadingData: false,
  },
  [tableIds.SEARCH_AND_CREATE_HISTORICAL_BUDGETS]: {
    id: tableIds.SEARCH_AND_CREATE_HISTORICAL_BUDGETS,
    isLoadingData: false,
  },
  [tableIds.REPORTING_ACTIONS]: {
    id: tableIds.REPORTING_ACTIONS,
    isLoadingData: false,
  },
  [tableIds.REPORTING_ACCIDENTS]: {
    id: tableIds.REPORTING_ACCIDENTS,
    isLoadingData: false,
  },

  // Fase 3 nav Trabajo/Revisión (rework, 2026-07-12) — tableIds del LISTADO
  // del módulo RV (GeneralViewRoutePage). Añadidos aquí explícitamente
  // (mismo criterio que el FIX de arriba): sin esto funcionarían "por
  // accidente" (el selector retorna undefined → tratado como false), pero
  // mejor explícito.
  [tableIds.RV_ACTIONS]: {
    id: tableIds.RV_ACTIONS,
    isLoadingData: false,
  },
  [tableIds.RV_MULTIMEDIA]: {
    id: tableIds.RV_MULTIMEDIA,
    isLoadingData: false,
  },

  // Pestañas de módulo del LISTADO de Campañas (`GeneralViewCampaignPage`).
  // Mismo criterio que RV_* arriba.
  [tableIds.CAMPAIGN_LIST_ACTIONS]: {
    id: tableIds.CAMPAIGN_LIST_ACTIONS,
    isLoadingData: false,
  },
  [tableIds.CAMPAIGN_LIST_ACCIDENTS]: {
    id: tableIds.CAMPAIGN_LIST_ACCIDENTS,
    isLoadingData: false,
  },
  [tableIds.CAMPAIGN_LIST_COMMUNICATIONS]: {
    id: tableIds.CAMPAIGN_LIST_COMMUNICATIONS,
    isLoadingData: false,
  },
  [tableIds.CAMPAIGN_LIST_MULTIMEDIA]: {
    id: tableIds.CAMPAIGN_LIST_MULTIMEDIA,
    isLoadingData: false,
  },
};

type actionType = {
  type: string;
  payload: {
    id: string;
    isLoadingData: boolean;
  };
};

export default function loadingData(
  state = initialLoadingDataState,
  { type, payload }: actionType
) {
  switch (type) {
    case LOADING_DATA:
      return {
        ...state,
        [payload.id]: {
          id: payload.id,
          isLoadingData: payload.isLoadingData,
        },
      };
    default:
      return state;
  }
}
